import { doc, FieldValue, updateDoc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IPlan } from "@leedpulse-monorepo/interfaces";
import { flattenObject } from "@leedpulse-monorepo/utils";

async function updatePlanBetter(
  id: string,
  body: Partial<Omit<IPlan, 'id'>>,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdatePlanFailure("Unauthorized", "unauthorized");
  }
  try {
    const updates: Record<string, FieldValue | Partial<unknown> | undefined> = flattenObject(body);

    const db = firestore;

    console.log('Updating plan: ', id, updates);
    await updateDoc(
      doc(db, FirestoreCollections.plans, id),
      updates
    );

    return;
  } catch (e) {
    console.log("error: ", e);
    throw new UpdatePlanFailure();
  }
}

export class UpdatePlanFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default updatePlanBetter;
